(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-tabs"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.category-tab').forEach((tab, index) => {

  tab.addEventListener('click', () => {
    document.querySelectorAll('.category-tab').forEach(t => t.classList.remove('active'));
    tab.classList.add('active');

    document.querySelectorAll('[data-products]').forEach(p => {
      p.style.display = 'none';
    });

    document.querySelector(`[data-products="${index}"]`).style.display = 'grid';
  });

  tab.addEventListener('dblclick', () => {
    const url = tab.dataset.url;
    if (url) {
      window.location.href = url;
    }
  });

  if (index === 0) {
    tab.classList.add('active');
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
